<template>
  <main class="dashboard-page">
    <section class="dashboard-page-section">
      <div class="dashboard-page-section-l">
        <!-- 我的询盘 -->
        <MyRfq v-if="!(brandBusinessModel.length == 1 && brandBusinessModel[0] == 2)"/>
        <!-- 询盘未读消息 -->
        <rfqUnreadMessage v-if="unReadNum" :unReadNum="unReadNum"/>
        <!-- 生态订单概况 -->
        <EcologicalOrder/>
        <!-- 产品管理 -->
        <ProductManage />
        <!-- 我的营销邮件 -->
        <MyMail v-if="$store.state.historySubscribeKit"/>
        <!-- 我的数据助手 -->
        <DataAssistant />
        <!-- 询盘推荐 -->
        <RecommendRfq v-if="!(brandBusinessModel.length == 1 && brandBusinessModel[0] == 2)"/>
      </div>
      <div class="dashboard-page-section-r">
        <!-- 个人卡片 -->
        <Information />
        <!-- 会员信息 -->
        <MemberInfo />
        <!-- 热门活动 -->
        <HotActivity />
        <!-- 最新动态 -->
        <LatestNews/>

        <!-- 外贸课堂 -->
        <!-- <TradeClassroom /> -->
        <!-- 客户经理 -->
        <AccountManager />
        <!-- 更新公告 -->
        <Announcement/>
        <!-- 产品更新弹框 -->
        <ProductDialog :info="productObj" :visible="productDialogVisible" @close="productDialogClose"></ProductDialog>
      </div>
    </section>

  </main>
</template>

<script>
import MyRfq from '@/components/dashboard/myRfq.vue';
import EcologicalOrder from '@/components/dashboard/ecologicalOrder.vue';
import ProductManage from '../components/dashboard/productManage.vue';
import MyMail from '@/components/dashboard/myMail.vue';
import RecommendRfq from '@/components/dashboard/recommendRfq.vue';
import HotActivity from '@/components/dashboard/hotActivity.vue';
import LatestNews from '@/components/dashboard/latestNews.vue';
import rfqUnreadMessage from '@/components/dashboard/rfqUnreadMessage.vue'
// import TradeClassroom from '@/components/dashboard/tradeClassroom.vue';
import AccountManager from '@/components/dashboard/accountManager.vue';
import MemberInfo from '@/components/dashboard/memberInfo.vue';
import Information  from '@/components/dashboard/Information.vue';
import DataAssistant from '@/components/dashboard/dataAssistant.vue';
import Announcement from '@/components/dashboard/announcement.vue';
import ProductDialog from '@/components/common/ProductDialog.vue'
import { getVersion,getUnReadMessageNum } from '@/utils/api/dashboard'
import Cookies from 'js-cookie'
import {mapState} from "vuex"
export default {
  data(){
    return{
      productDialogVisible: false,
      productObj: {},
      unReadNum:0
    }
  },
  components: {
    MyRfq,
    EcologicalOrder,
    ProductManage,
    MyMail,
    RecommendRfq,
    HotActivity,
    // TradeClassroom,
    AccountManager,
    MemberInfo,
    Information,
    DataAssistant,
    LatestNews,
    Announcement,
    ProductDialog,
    rfqUnreadMessage
  },
  methods:{
    async getVersionFn() {
      try {
        const res = await getVersion()
        if (res.rspResult.bizCode == 200) {
          if (res.data.id) {
            const data = Cookies.get('isProduct') ? JSON.parse(Cookies.get('isProduct')) : null
            if (data) {
              // 获取当前时间戳（毫秒）
              const currentTimestamp = Date.now()
              console.log(currentTimestamp, data.date)
              if (res.data.id == data.id) {
                if (currentTimestamp > data.date) {
                  this.productDialogVisible = true
                  this.productObj = res.data
                  Cookies.remove('isProduct')
                }
              } else {
                this.productDialogVisible = true
                this.productObj = res.data
              }
            } else {
              this.productDialogVisible = true
              this.productObj = res.data
            }
          }else{
            if (this.productDialogVisible) {
              this.productDialogVisible = false
            }
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    getUnReadMessageNum() {
      const params = {
        t: Date.now(),
      }
      getUnReadMessageNum(params).then((res) => {
        if (res.rspResult.bizCode == 200) {
          this.unReadNum = res.data.unReadNum || 0 //匹配询盘
        }
      })
    },
    productDialogClose() {
      this.productDialogVisible = false
    }
  },
  mounted() {
    this.getVersionFn()
    this.getUnReadMessageNum()
  },
  computed:{
    ...mapState(['brandBusinessModel'])
  }
}
</script>

<style lang="scss">
.dashboard-page {
  .model-title {
    display: inline-block;
    height: 14px;
    line-height: 14px;
    font-family: SourceHanSansCN-Bold;
    font-weight: 700;
    font-size: 14px;
    color: #16181A;
    letter-spacing: 0;
    text-align: justify;
    margin-bottom: 16px;
  }
  &-cont {
    margin-bottom: 12px;
  }
  &-section {
    display: flex;
    &-l {
      flex: 1;
    }
    &-r {
      transition: width .3s;
      width: 428px;
      margin-left: 12px;
      flex-shrink: 0;
      height: max-content;
    }
  }
  
}

</style>